import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const STEPS = [
  { n: "01", title: "Come alone.", text: "Many Roamies arrive solo — that's what makes meeting your crew part of the adventure. Some trips welcome a friend too; each trip states its policy." },
  { n: "02", title: "Meet your crew.", text: "Start local with a Roamies IRL event, or dive straight into a weekend drop. The group chat opens before you ever pack a bag." },
  { n: "03", title: "Travel together.", text: "Weekend trips, then flagship international escapes — with people who started as strangers and stopped being strangers fast." },
  { n: "04", title: "Leave with a family.", text: "The crew that watched the sunset with you is the crew you text next month. That's the whole point." },
];

export const CommunityFlow = () => (
  <section id="how-it-works" className="bg-ink text-cream noise-bg py-16 sm:py-20" data-testid="community-flow-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-14">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-flame mb-4">How It Works</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95]">
          The Roamies ladder.
        </h2>
        <p className="mt-5 max-w-2xl text-cream/70 leading-relaxed">
          Start small or go big — a local Roamies IRL meetup, a weekend drop, then the flagship international escape. Each rung is the same crew energy, bigger stakes.
        </p>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {STEPS.map((step, i) => (
          <motion.div
            key={step.n}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            data-testid={`community-step-${i + 1}`}
            className="relative border border-cream/15 p-7 hover:border-flame transition-colors group"
          >
            <span className="font-display text-5xl text-outline-cream group-hover:text-flame group-hover:[-webkit-text-stroke:0] transition-colors">{step.n}</span>
            <h3 className="font-display text-2xl uppercase mt-5">{step.title}</h3>
            <p className="mt-3 text-sm text-cream/65 leading-relaxed">{step.text}</p>
            {i < STEPS.length - 1 && (
              <ArrowDown className="w-5 h-5 text-flame mt-6 md:hidden" />
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
